import moment from "moment";
export const getSchedule = async (ScheduleDetail, Time) => getScheduleByScheduleDetail(ScheduleDetail, Time);
export const getScheduleDeatail = async (Schedule) => getScheduleDetailBySchedule(Schedule);

function getScheduleDetailBySchedule(Schedule) {
  if(Schedule == null)
    return;

  let scheduleArray = Schedule.split(' ');

  const minutes = Number(scheduleArray[1]);
  const hours = Number(scheduleArray[2]);

  const time = new Date();
  time.setMinutes(minutes);
  time.setHours(hours);


  const offset = moment(time).utcOffset();
  const local = moment(time).add(offset, 'minutes').format('HH:mm').split(':');
  
  time.setHours(local[0]);
  time.setMinutes(local[1]);


  if(scheduleArray[3] == "?" && scheduleArray[5] != "*") { //week
    const result = {
      id: "WEEKLY",
      weeks: {
        days: scheduleArray[5].split(',')
      },
      time: time
    }
    return result;
  } else if(scheduleArray[3] == "?" && scheduleArray[5] == "*") { //day
    const result = {
      id: "DAILY",
      time: time
    }
    return result;
  } else { // montly
    
    let day = scheduleArray[3];
    if(day == "L") {
      const result = {
        id: "MONTHLY",
        monthly: {
          lastdayofmonth: true,
          dayofmonth: 1
        },
        time: time
      }
      return result;
    } else {
      const result = {
        id: "MONTHLY",
        monthly: {
          lastdayofmonth: false,
          dayofmonth: Number(day)
        },
        time: time
      }
      return result;
    }
  }
}

function getScheduleByScheduleDetail(ScheduleDetail, Time) {
  const time = moment.utc(Time).format('HH:mm').split(':');
  const hours = time[0];
  const minutes = time[1];
  
  if(ScheduleDetail == null)
    return;
  let schedule;
  switch(ScheduleDetail.id) {
    case 'DAILY':
        schedule = getScheduleDetailDaily(minutes, hours);
        break;
    case 'WEEKLY':
        schedule = getScheduleDetailWeekly(minutes, hours, ScheduleDetail.weeks.days);
        break;
    case 'MONTHLY':
        schedule = getScheduleDetailMonthly(minutes, hours, ScheduleDetail.monthly);
        break;
    default:
        break;
  }
  return schedule;
}

function getScheduleDetailDaily(minutes, hours) {
  return (`0 ${minutes} ${hours} ? * * *`);
}

function getScheduleDetailWeekly(minutes, hours, weeks) {
  let weekString = new String;
  weekString = weeks[0];

  for(let i = 1; i < weeks.length; i++) {
    weekString = weekString + ',' + weeks[i];
  }
  return (`0 ${minutes} ${hours} ? * ` + weekString + " *");
}

function getScheduleDetailMonthly(minutes, hours, monthly) {
  
  let day = (monthly.lastdayofmonth === true) ? "L" : monthly.dayofmonth;
  
  return (`0 ${minutes} ${hours} ` + day + " * ? *");
}